import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';

export class JsonCWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.jsonc.ID;
        this.name = DatabaseEnum.jsonc.NAME;
        this.code = DatabaseEnum.jsonc.CODE;
        this.equivalentTag = DatabaseEnum.jsonc.EQUIVALENT_TAG;
        this.showLoadPropertiesTab = false;
        this.showExtractPropertiesTab = true;
        this.showDatabaseTab = false;
        this.isFileType = true;
        //this.isNeedRedirectForTestDP = true;
        this.disableTestDataPointButton = false;
        this.importFileProperties();
        this.showDataDescription = false;
    }

    validateRepConn(repConnWrapper: RepConnWrapper): void {

        if (String(repConnWrapper.repConn.conn.batchSize) == 'null' ||
            String(repConnWrapper.repConn.conn.batchSize) == '') {
            repConnWrapper.inValid_Cds.push('ESM00671');
        } else if (String(repConnWrapper.repConn.conn.timeOut) == 'null' ||
            String(repConnWrapper.repConn.conn.timeOut) == '') {
            repConnWrapper.inValid_Cds.push('ESM00672');
        }

        /*else if( repConnWrapper.repConn.conn.accessToken == '' ){
            repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
        }*/

        if (repConnWrapper.repConn.conn.access_Token_Flg == 'Y') {
            if (repConnWrapper.repConn.conn.consumerKey == "") {
                repConnWrapper.inValid_Cds.push('CONS_KEY');
            }

            if (repConnWrapper.repConn.conn.consumerSecret == "") {
                repConnWrapper.inValid_Cds.push('CONS_SEC');
            }

            if (repConnWrapper.repConn.conn.url == "") {
                repConnWrapper.inValid_Cds.push('CBK_URL');
            }
        }
        // if (repConnWrapper.repConn.conn.accessToken == "") {
        //     repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
        // }
        // if (repConnWrapper.repConn.conn.accessTokenSecret == "") {
        //     repConnWrapper.inValid_Cds.push('REFRESH_TOKEN');
        // }
        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }
    }

    importFileProperties() {
        this.showFileTypeGroup = true;
        this.showDelimiter = true;
        this.showFixedWidth = true;
    }

    readFileCutOffLength(type: string): number {
        if (type == "FILE") {
            return 49; //default 50 lines index starts from 0
        }

        return -1;
    }

}
